import {isEmpty, isNil, getRelativePositionToParent, getStringSha256Hash} from '../../../helpers'
import TitlePopup from "../../popup/TitlePopup";

const MODE_GRID = 'grid';
const MODE_LIST = 'list';
const ALLOWED_MODES = [MODE_LIST, MODE_GRID];

export default class ColorFilter {
    constructor(_root) {
        this._root = _root
        this._switchButtons = Array.from(this._root.querySelectorAll('button.switch-mode'))
        this._contentContainer = this._root.querySelector('.product__filter_box__body')
        this._setupEventListeners()
        this._initialize()
    }

    _initialize() {
        const initialMode = MODE_GRID;
        const contentContainerClasses = Array.from(this._contentContainer.classList);
        this._assignIdentifier();
        this._adjustTitle();

        if (
            this._contentContainer &&
            !contentContainerClasses.includes('product__filter_grid-mode') &&
            !contentContainerClasses.includes('product__filter_list-mode')
        ) {
            this._changeMode(initialMode);
        }

        this._adjustTooltipOffset();
        this._createPictureNumberingElement();
    }

    _setupEventListeners() {
        this._switchButtons.forEach(_switchButton => {
            _switchButton.addEventListener('click', this._switchMode.bind(this))
        });
    }

    _switchMode(_event) {
        _event.preventDefault();
        const button = _event.currentTarget;
        const mode = button.getAttribute('data-mode');

        if (!ALLOWED_MODES.includes(mode)) {
            return false;
        }

        this._changeMode(mode);
        this._switchTooltipOffset(mode);
    }

    _changeMode(mode) {
        this._switchButtons.forEach(_button => {
            const isSelected = _button.getAttribute('data-mode') === mode;
            _button.setAttribute('aria-selected', isSelected)
            _button.classList.remove('mode--active')
        })

        const button = this._root.querySelector(`.switch-mode.${mode}-mode`);
        if (!isNil(button)) {
            button.classList.add('mode--active');
        }

        const titlePopups = new TitlePopup('.filter__color-scale [data-title]');
        if (mode === MODE_GRID) {
            this._contentContainer.classList.remove('product__filter_list-mode');
            titlePopups.init();
        }

        if (mode === MODE_LIST) {
            this._contentContainer.classList.remove('product__filter_grid-mode');
            titlePopups.destroyAll();
        }

        this._contentContainer.classList.add('product__filter_' + mode + '-mode');
    }

    _createPictureNumberingElement() {
        const imageBoxes = Array.from(this._contentContainer.querySelectorAll('.product__filter_box_item__with_Image'));
        const classes = ['product__filter_box_item_index', 'text', 'text--small'];
        imageBoxes.forEach(_imageBox => {
            const text = _imageBox.innerText;
            const words = text.split(' ');
            const numberString = words.length ? words[0] : ''

            if (!isEmpty(numberString)) {
                let element = document.createElement('span');
                element.classList.add(...classes)
                element.innerText = numberString;
                _imageBox.appendChild(element);
            }
        })
    }

    _switchTooltipOffset(mode) {
        const imageBoxes = Array.from(this._contentContainer.querySelectorAll('.product__filter_box_item_value'));
        imageBoxes.forEach(_imageBox => {
            const selector = mode === MODE_LIST ? 'data-tooltip-initial-offset' : 'data-tooltip-offset-grid';
            const offset = _imageBox.getAttribute(selector);
            _imageBox.setAttribute('data-tooltip-offset', offset);
        })

        window.dispatchEvent(
            new CustomEvent('reinitializeTooltips')
        );

    }

    _adjustTooltipOffset() {
        const items = Array.from(this._contentContainer.querySelectorAll('.product__filter_box_item_value'));
        items.forEach(_item => {
            const offset = _item.getAttribute('data-tooltip-initial-offset');
            const initialOffset = offset.split(',');
            if (initialOffset) {
                const relativePosition = getRelativePositionToParent(_item);
                const gridOffset = [initialOffset[0], relativePosition.left];
                _item.setAttribute('data-tooltip-offset-grid', gridOffset.join(','));
                _item.setAttribute('data-tooltip-offset', gridOffset.join(','));
            }
        })
    }

    _assignIdentifier() {
        const items = Array.from(this._contentContainer.querySelectorAll('.product__filter_box_item_value'));
        items.forEach(_item => {
            const valueElement = _item.querySelector('.product__filter_box_item__with_Image');
            const value = !isNil(valueElement) ? valueElement.innerText : '';
            const hash = getStringSha256Hash(value);
            _item.setAttribute('id', hash);
        })
    }

    _adjustTitle() {
        const items = Array.from(this._contentContainer.querySelectorAll('.product__filter_box_item_value'));
        items.forEach(_item => {
            const title = _item.getAttribute('data-title');
            const regex = /^(?:[0-9]{2}?)/gm;
            const newTitle = title.replace(regex, '');
            _item.setAttribute('data-title', newTitle.trim());
        })
    }
}



// WEBPACK FOOTER //
// ./Private/Scripts/components/product/Filter/ColorFilter.js